export function isRosterAvailable(masterEvent) {
  return !!masterEvent?.bazuServices?.find(x => x.serviceName === 'Dirty Startlists' && x.available)
}